import { render, staticRenderFns } from "./Wares.vue?vue&type=template&id=539e56d8&"
import script from "./Wares.vue?vue&type=script&lang=js&"
export * from "./Wares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports